import { createFileRoute } from "@tanstack/react-router";
import NavBar from "#/components/navbar/navbar";
import Footer from "#/components/footer/footer";
import Mdx from "#/components/MdxRemote";
import { metadataToHead } from "#/lib/seo";

export default function Terms() {
  return (
    <>
      <header>
        <NavBar />
      </header>
      <main id="content" className="mx-auto mt-24 max-w-3xl space-y-10">
        <h1 className="text-center text-5xl">Terms of Use</h1>

        <section className="mx-8 space-y-5">
          <Mdx source={content} />
        </section>
      </main>
      <Footer />
    </>
  );
}

const content = `
## 1. Acceptance of Terms
- By using Roamdoc.com, users agree to these Terms of Use. If you do not agree, you should not use this website.

## 2. Description of Service
- Roamdoc provides job listings for Anesthesiologists and CRNAs, including permanent and locum positions.

## 3. User Registration and Privacy
- Users may be required to register and provide personal information such as email addresses.
- Personal information will be used to create job alerts and contact users regarding job openings or opportunities to work with recruiters.
- Our privacy policy, which forms part of these terms, outlines how we handle user data.

## 4. User Obligations
- Users agree to provide accurate and current information.
- Users must not use the website for any illegal or unauthorized purpose.

## 5. Intellectual Property Rights
- All content on Roamdoc is the property of Roamdoc or its licensors and is protected by copyright and intellectual property laws.

## 6. Limitation of Liability
- Roamdoc is not responsible for any direct, indirect, incidental, or consequential damages resulting from the use or inability to use the service.

## 7. Disclaimer of Warranties
- Roamdoc provides its service "as is" and does not make any warranty, express or implied, regarding the service.

## 8. Indemnification
- Users agree to indemnify and hold Roamdoc harmless from any claim or demand made by any third party due to or arising out of their use of the service.

## 9. Modification of Terms
- Roamdoc reserves the right to modify these terms at any time.

## 10. Governing Law
- These terms will be governed by and construed in accordance with the laws of the jurisdiction in which Roamdoc operates.

## 11. Contact Information
- For any questions regarding these Terms of Use, please contact [roamdoc.com/contact-roamdoc](https://roamdoc.com/contact-roamdoc).
`;

export const metadata = {
  title: "Terms of Use • Roamdoc",
  description: "Terms of Use for Roamdoc.",
  icons: [{ rel: "icon", url: "/favicon.ico" }],
  openGraph: {
    images: ["https://www.roamdoc.com/og-image.png"],
  },
  alternates: {
    canonical: `https://www.roamdoc.com/terms-of-use`,
  },
};

export const Route = createFileRoute("/(legal)/terms-of-use/")({
  component: Terms,
  head: () => metadataToHead(metadata),
});
